import { useState } from 'react';

export const DropDown = ({ titleIcon, dropdownArray, title, triggerClass, listClass }) => {
  const [display, setDisplay] = useState(false)
  return (
      <div className='relative'>
        <div className={triggerClass} onClick={() => setDisplay(prevState => !prevState)}>
          <div>{title && title}</div>
          <div>{titleIcon && titleIcon}</div>
        </div>
        {
          display && (
            <>
                <div onClick={() => setDisplay(false)} className="w-screen h-screen fixed inset-0 z-[9999] bg-black opacity-20"></div>
                <div className="top-[3.5rem] absolute -right-[1rem] buttom-[-4rem] border bg-[#FFFFFF] overflow-hidden dropdownNew z-[10000]" style={{borderRadius: "8px", minWidth: 'auto', width: 'auto'}}>
                    {
                        dropdownArray.map((item, index) => {
                            const { icon, title, func, color, isFreeze } = item;
                            return (
                                <div key={index} className={`${listClass} z-[11000] hover:bg-[#F9FAFB] ${isFreeze ? "cursor-not-allowed pointer-events-none" : ""}`}
                                onClick={() => {
                                  if (!isFreeze) {
                                    setDisplay(false);
                                    func();
                                  }
                                  }}>
                                    {icon && icon}
                                    {title && (
                                        <div className={`${color ? color : ""} text-nowrap`}>{title}</div>
                                    )}
                                </div>
                            )
                        })
                    }
                </div>
            </>
          )
        }
      </div>
  )
}


export default DropDown;